import React from 'react';
import { Link } from 'react-router-dom';
import { useAppDispatch, useIsAuthenticated } from '@/hooks/redux';
import {
  openProhibitedTerritoriesModal,
  openRulesModal,
  openUnderageModal,
} from '@/store/slices/modalSlice';
import { cn } from '@/utils';

const Footer: React.FC<{ footerClassName?: string; className?: string; isInvert?: boolean }> = ({
  footerClassName = '',
  className = '',
  isInvert,
}) => {
  const dispatch = useAppDispatch();
  const isAuthenticated = useIsAuthenticated();

  return (
    <footer
      style={{
        backgroundImage: 'linear-gradient(rgb(111, 111, 111), rgb(15, 15, 15))',
      }}
      className={cn('relative', footerClassName)}
    >
      <div className={`relative w-full text-white text-[12px] ${className}`}>
        <div className="  md:max-w-[90%] md:mx-auto py-1.5">
          {/* Top Row */}
          <div className="flex flex-col md:flex-row items-center justify-center">
            {/* Left — SSL */}

            {/* Center — Links + Badges */}
            <div className="flex flex-col items-center text-center">
              <div className="font-extrabold text-lg">24X7 Support</div>

              <div className="max-md:w-full md:absolute md:left-4 md:top-2 md:flex md:gap-2">
                <img
                  src="/images/ssl.png"
                  alt="SSL"
                  className="w-[80px] xl:w-[101px] object-contain"
                />
                <div className="hidden 2xl:flex flex-col">
                  <span className="text-xl font-bold">100% SAFE</span>
                  <span className="text-sm">Protected connection and encrypted data</span>
                </div>
              </div>

              <div
                className={`flex items-center gap-4 gap-y-0 flex-wrap justify-center text-base font-bold ${isInvert ? 'mb-4' : ''}`}
              >
                {isAuthenticated && (
                  <>
                    <Link to="/faq" className="cursor-pointer hover:underline">
                      FAQ
                    </Link>
                    <button
                      type="button"
                      onClick={() => dispatch(openRulesModal())}
                      className="cursor-pointer hover:underline"
                    >
                      Rules
                    </button>
                  </>
                )}
                <Link
                  to="/terms-and-conditions"
                  target="_blank"
                  className="cursor-pointer hover:underline"
                >
                  Terms and Conditions
                </Link>
                <Link
                  to="/responsible-gaming"
                  target="_blank"
                  className="cursor-pointer hover:underline"
                >
                  Responsible Gaming
                </Link>
              </div>

              {/* Badges Row */}
              <div className="flex items-center gap-3 gap-y-1 flex-wrap justify-center mt-1">
                <button
                  type="button"
                  onClick={() => dispatch(openUnderageModal())}
                  className="cursor-pointer"
                  aria-label="Underage gambling"
                >
                  <img src="/images/18plus.png" alt="18+" className="h-[15px] md:h-5 border-r pr-2" />
                </button>
                <a
                  href="https://www.gamcare.org.uk/"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="GamCare"
                >
                  <img src="/images/gamecare.png" alt="Gamecare" className=" h-[15px] md:h-5 border-r pr-2" />
                </a>
                <a
                  href="https://gamblingtherapy.org/"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Gambling Therapy"
                >
                  <img src="/images/gt.png" alt="GT" className="h-[15px] md:h-5 border-r pr-2" />
                </a>
                <a
                  href="https://www.gambleaware.org/home/"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="GambleAware"
                >
                  <img
                    src="/images/gamble-aware.svg"
                    alt="Gamble Aware"
                    className={`h-[15px] md:h-5 ${isInvert ? 'invert' : ''}`}
                  />
                </a>
                <a
                  href="https://www.gamstop.co.uk/"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Gamstop"
                >
                  <img src="/images/game-stop.png" alt="Gamstop" className="h-[15px] md:h-5 border-x px-2" />
                </a>

                <button
                  type="button"
                  onClick={() => dispatch(openProhibitedTerritoriesModal())}
                  className="cursor-pointer hover:underline text-sm font-bold"
                >
                  Prohibited Territories
                </button>
              </div>
            </div>
          </div>

          {/* Bottom copyright */}
          <div
            className={`text-center text-sm  pt-4 my-1 border-t border-dashed ${isInvert ? 'border-white' : 'border-black'}`}
          >
            © Copyright {new Date().getFullYear()}. All Rights Reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
